<template>
  <div>
    <el-dialog
      :visible="!!editingChangeRow"
      title="掌门竞选"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="130px">
        <el-form-item label="掌门价格">
          <el-input-number
            v-model="detail.ownerPrice"
            placeholder="FBS"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="掌门递增最小价格">
          <el-input-number
            v-model="detail.ownerPriceStep"
            placeholder="FBS"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="每次竞选延长时间">
          <el-input-number
            v-model="detail.ownerTimeMinuteStep"
            placeholder="分钟"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="竞选">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-date-picker
                v-model="detail.nextOwnerChangeTime"
                value-format="timestamp"
                type="datetime"
                placeholder="开始时间"
              ></el-date-picker>
            </el-col>
            <el-col :span="7">
              <el-date-picker
                v-model="detail.nextOwnerChangeEndTime"
                value-format="timestamp"
                type="datetime"
                placeholder="开始时间"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'leagueDetail',
  props: ['editingChangeRow'],
  data() {
    const validateUnlockEndTime = (rule, value, callback) => {
      if (!this.detail.nextUnlockEndTime) {
        callback();
      }
      if (
        this.detail.nextUnlockStartTime &&
        this.detail.nextUnlockEndTime &&
        value < this.detail.nextUnlockStartTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };

    const validateOwnerEndTime = (rule, value, callback) => {
      if (!this.detail.nextOwnerChangeEndTime) {
        callback();
      }
      if (
        this.detail.nextOwnerChangeTime &&
        this.detail.nextOwnerChangeEndTime &&
        value < this.detail.nextOwnerChangeTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };

    return {
      dialogVisible: false,
      detail: {},
      rules: {
        ownerPrice: {
          required: true,
          message: '请填写'
        },
        ownerPriceStep: {
          required: true,
          message: '请填写'
        },
        ownerTimeMinuteStep: {
          required: true,
          message: '请填写'
        },
        nextOwnerChangeEndTime: [
          {
            validator: validateOwnerEndTime,
            trigger: 'change'
          }
        ]
      }
    };
  },
  watch: {
    editingChangeRow(val) {
      this.detail = (val && { ...val }) || {};
    }
  },
  methods: {
    ...mapActions('league', ['setOwnerChange']),
    closeDialog() {
      this.$emit('close');
    },

    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.setOwnerChange({ ...this.detail, leagueId: this.detail.id }).then(
        () => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.closeDialog();
          this.$emit('refresh');
        }
      );
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
